import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { styled } from '@stitches/react'
import { Icon } from 'components/common/Icon'
import React from 'react'
import { tooltipArrowStyle, tooltipContentStyle } from '../../constants'

type Props = {
  children?: React.ReactNode
  content?: string | React.ReactNode
  open?: boolean
  defaultOpen?: boolean
  className?: string
  disableHoverableContent?: boolean
  onOpenChange?: (open: boolean) => void
  hideArrow?: boolean
  side?: 'top' | 'right' | 'bottom' | 'left'
  triggerClassName?: string
}

const TooltipPrimitiveContent = styled(
  TooltipPrimitive.Content,
  tooltipContentStyle
)
const TooltipPrimitiveArrow = styled(TooltipPrimitive.Arrow, tooltipArrowStyle)

export const Tooltip = ({
  children,
  content,
  open,
  defaultOpen,
  disableHoverableContent,
  onOpenChange,
  side = 'top',
  className,
  hideArrow = false,
  triggerClassName = '',
  ...props
}: Props) => {
  const trigger = (
    <span tabIndex={0} className={triggerClassName}>
      {children ? (
        children
      ) : (
        <Icon
          name='tooltip'
          className='cursor-pointer text-cool-500'
          size={16}
        />
      )}
    </span>
  )

  if (!content) return trigger

  return (
    <>
      <TooltipPrimitive.Provider delayDuration={0}>
        <TooltipPrimitive.Root
          open={open}
          defaultOpen={defaultOpen}
          onOpenChange={onOpenChange}
          disableHoverableContent={disableHoverableContent}
        >
          <TooltipPrimitive.Trigger asChild>{trigger}</TooltipPrimitive.Trigger>
          <TooltipPrimitive.Portal>
            <TooltipPrimitiveContent
              side={side}
              align='center'
              className={className}
              {...props}
            >
              <div className='font-body text-sm'>{content}</div>
              {!hideArrow && <TooltipPrimitiveArrow width={16} height={8} />}
            </TooltipPrimitiveContent>
          </TooltipPrimitive.Portal>
        </TooltipPrimitive.Root>
      </TooltipPrimitive.Provider>
    </>
  )
}
